import { useAppDispatch, useAppSelector } from "@/config/store";
import { Button } from "@/components/ui";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui";
import { IEdoUnit } from "@/shared/model/edo-unit.model";
import { useEffect } from "react";
import { Translate } from "react-jhipster";
import { deleteEntity } from "../../../shared/reducers/entities/edo-unit.reducer";

export interface DeleteUnitProps {
  unit: IEdoUnit;
  open: boolean;
  handleClose: (updated: boolean) => void;
}

export const DeleteUnit = (props: DeleteUnitProps) => {
  const dispatch = useAppDispatch();
  const updateSuccess = useAppSelector<boolean>(
    (state) => state.edoUnit.updateSuccess
  );

  const { open, handleClose, unit } = props;

  const handleCloseDialog = () => {
    handleClose(false);
  };

  const confirmDelete = () => {
    dispatch(deleteEntity(unit.id));
  };

  useEffect(() => {
    if (updateSuccess) {
      handleCloseDialog();
    }
  }, [updateSuccess]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleCloseDialog()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Translate contentKey="entity.delete.title">
              Confirm delete operation
            </Translate>
          </DialogTitle>
        </DialogHeader>
        <p className="text-body text-[var(--color-mockup-text-mid)]">
          <Translate
            contentKey="edocendoApp.edoUnit.delete.question"
            interpolate={{ nome: unit?.title }}
          >
            Are you sure you want to delete this EdoUnit?
          </Translate>
        </p>
        <DialogFooter className="gap-2 pt-4">
          <Button variant="outline" onClick={handleCloseDialog}>
            <Translate contentKey="entity.action.cancel">Cancel</Translate>
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            <Translate contentKey="entity.action.delete">Delete</Translate>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
